import { TypeExtends } from "sb-js-extends";
TypeExtends();
export const getDailyHours = (startHours, formatStyle) => {
    const dailyHours = [];
    for (startHours; startHours < 24; startHours++) {
        dailyHours.push({
            id: startHours.toString(),
            name: new Date(0, 0, 0, startHours, 0, 0, 0).formatDate(formatStyle)
        });
    }
    return dailyHours;
};
//# sourceMappingURL=getDailyHours.js.map